import { render } from "./VUEConfirm.vue?vue&type=template&id=3ad42761"
import script from "./VUEConfirm.vue?vue&type=script&lang=js"
export * from "./VUEConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__